/* Module that loads a user's custom module that was specified within the Publishing Template. */
import options from '../options/options.js';
import util from '../util/util.js';

/**
 * @type {string}
 *
 * The ID of the Publishing Template base directory as it is specified in the configuration
 * object passed to the RequireJS library used to load the JS modules.
 */
const TEMPLATE_BASE_DIR_ID = 'template-base-dir';

/**
 * @type {string}
 *
 * Specifies if the custom JavaScript module specified in the Publishing Template
 * should be loaded or not.
 */
const isTemplateJsModuleLoadingEnabled = options.getBoolean('webhelp.enable.template.js.module.loading');

/**
 * @type {string}
 *
 * The path of the template's main JS module relative to the base directory of the Publishing Template.
 */
const templateMainJsModuleRelPath = options.get('webhelp.js.module.rel.path');

/**
 * Computes the ID of the template's main JS module.
 *
 * @param templateMainJsModuleRelPath The path of the template's main JS module
 *                              relative to the base directory of the Publishing Template.
 */
function getTemplateMainJsID(templateMainJsModuleRelPath) {
    // Remove .js extension
    const ext = '.js';
    let templateMainJsRelPathNoExt;
    if (templateMainJsModuleRelPath.endsWith(ext)) {
        templateMainJsRelPathNoExt = templateMainJsModuleRelPath.substring(
            0,
            templateMainJsModuleRelPath.length - ext.length,
        );
    } else {
        templateMainJsRelPathNoExt = templateMainJsModuleRelPath;
    }

    return TEMPLATE_BASE_DIR_ID + '/' + templateMainJsRelPathNoExt;
}

// Load the template's main JS module if enabled
if (isTemplateJsModuleLoadingEnabled && templateMainJsModuleRelPath) {
    const templateMainJsID = getTemplateMainJsID(templateMainJsModuleRelPath);
    try {
        // Using dynamic import for loading the template module
        import(/* @vite-ignore */ templateMainJsID + '.js')
            .then(() => {
                util.debug('Finished loading custom script:', templateMainJsModuleRelPath);
            })
            .catch((err) => {
                console.error('Cannot load script:', templateMainJsModuleRelPath, err);
            });
    } catch (err) {
        console.error('Cannot load script:', templateMainJsModuleRelPath, err);
    }
}

export default {
    getTemplateMainJsID
};
